import { ClientChannelType } from "@/types"

export const CHANNEL_SOURCE_FILTER_VALUES = [
  ClientChannelType.WEB,
  ClientChannelType.WIDGET,
  ClientChannelType.BROWSER_EXTENSION,
  ClientChannelType.SLACK,
  ClientChannelType.LINE,
  ClientChannelType.MESSENGER,
  ClientChannelType.INSTAGRAM,
] as const

const CHANNEL_SOURCE_LABEL_KEYS = {
  [ClientChannelType.WEB]: "web",
  [ClientChannelType.WIDGET]: "widget",
  [ClientChannelType.BROWSER_EXTENSION]: "browserExtension",
  [ClientChannelType.SLACK]: "slack",
  [ClientChannelType.LINE]: "line",
  [ClientChannelType.MESSENGER]: "messenger",
  [ClientChannelType.INSTAGRAM]: "instagram",
} satisfies Record<ClientChannelType, string>

const channelSourceLabelKeys: Readonly<Record<string, string>> =
  CHANNEL_SOURCE_LABEL_KEYS

export const getChannelSourceLabelKey = (
  channelType: string | null | undefined
) => (channelType ? channelSourceLabelKeys[channelType] : undefined)
